const memoryCache = new Map();
const inflightRequests = new Map();
const STORAGE_PREFIX = "balleralgo-api-cache:";

function now() {
  return Date.now();
}

function getStorageKey(key) {
  return `${STORAGE_PREFIX}${key}`;
}

function safeReadStorage(key) {
  try {
    const raw = window.sessionStorage.getItem(getStorageKey(key));
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
}

function safeWriteStorage(key, entry) {
  try {
    window.sessionStorage.setItem(getStorageKey(key), JSON.stringify(entry));
  } catch (error) {
    // Ignore storage failures and keep memory cache only.
  }
}

function isFresh(entry, ttlMs) {
  return Boolean(entry) && now() - entry.cachedAt <= ttlMs;
}

function getFreshEntry(key, ttlMs) {
  const memoryEntry = memoryCache.get(key);
  if (isFresh(memoryEntry, ttlMs)) {
    return memoryEntry;
  }

  const storageEntry = safeReadStorage(key);
  if (isFresh(storageEntry, ttlMs)) {
    memoryCache.set(key, storageEntry);
    return storageEntry;
  }

  return null;
}

export async function fetchJsonWithCache({ key, url, ttlMs = 30000 }) {
  const freshEntry = getFreshEntry(key, ttlMs);
  if (freshEntry) {
    return freshEntry.data;
  }

  if (inflightRequests.has(key)) {
    return inflightRequests.get(key);
  }

  const request = fetch(url, {
    headers: {
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
  })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      const entry = {
        data,
        cachedAt: now(),
      };
      memoryCache.set(key, entry);
      safeWriteStorage(key, entry);
      return data;
    })
    .finally(() => {
      inflightRequests.delete(key);
    });

  inflightRequests.set(key, request);
  return request;
}
